import type { Location } from '@/modules/shared/types/location.types'
import type { Appointment } from '../types/appointment.types'

/**
 * Where an appointment takes place: the Synops location when there is one, otherwise the e-sign
 * location in Dutch, shaped like a Synops one so the screens need only one type.
 */
function getAppointmentLocation(appointment: Appointment | undefined): Location | undefined {
  const location = appointment?.meta?.location
  if (location && typeof location !== 'string') {
    return location
  }

  const esign = appointment?.meta?.esign?.location
  if (!esign) {
    return undefined
  }

  return {
    id: esign.id,
    name: esign.name?.nl,
    address: esign.address
      ? {
          street: esign.address.street?.nl,
          postcode: esign.address.postcode?.nl,
          city: esign.address.city?.nl,
          country: esign.address.country?.nl,
        }
      : undefined,
  }
}

export { getAppointmentLocation }
